import * as React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import { InputFormat } from "../../Landing/Components/FormOptions/InputFormat";
import { Col, Row } from "react-bootstrap";
import { DropDownFormat } from "../../Landing/Components/FormOptions/DropDownFormat";
import TelInput from "../../Landing/Components/FormOptions/TelInput";
import { getProvince } from "../../StateManagement/ProvinceSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DataTableTemplate from "../Components/DataTableTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { PanelContainer } from "../Components/PanelContainer";
import SelectFormat from "../../Landing/Components/FormOptions/SelectFormat";
import { fetchData } from "../Components/Utilities";
import { useForm } from "react-hook-form";
import AvatarImg from "../../Assets/images/download.png";
import { CheckboxFormat } from "../../Landing/Components/FormOptions/CheckboxFormat";
import BranchesLoc from "../Components/BranchesLoc";
export const ControlShop = () => {
  const [selectedType, setSelectedType] = useState(null);
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [showEditComponent, setShowEditComponent] = useState(false);
  const [defaultRows, setDefaultRows] = useState(20);
  const [pageData, setPageData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [editingShopId, setEditingShopId] = useState(null);
  const [categoryList, setCategoryList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [ProvinceList, setProvinceList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [initialLogo, setInitialLogo] = useState("");
  const [qrcode, setQrcode] = useState("");
  const province = useSelector((state) => state?.province?.province);
  const [tokenValue, setTokenValue] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Logo, setLogo] = useState("");
  const [showMap, setShowMap] = useState(false);
  const [langData, setLangData] = useState("");
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });

  const defaultValues = {
    Title: "",
    MinimumCashBack: "",
    MaxsimumCashBack: "",
    province: "",
    city: "",
    Logo: "",
    ShopDesc: "",
    WebSite: "",
    CreateDate: "",
    ShopId: "",
    CatId: "",
    ManagerId: "",
    shopreagentmob: "",
    shoptaminmob: "",
    Address: "",
    status: "",
    catname: "",
    type: "",
    latlang: "",
  };
  const cols = [
    {
      field: "Title",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "Title",
      header: "نام",
    },
    { field: "CreateDate", header: "تاریخ عضویت" },
    {
      field: "catname",
      header: " دسته بندی",
    },
    // { field: "CreateDate", header: "تاریخ عضویت" },
    // {
    //   field: "status",
    //   header: "وضعیت",
    // },
    {
      field: "MinimumCashBack",
      header: "حداقل کش بک",
    },
    { field: "MaxsimumCashBack", header: "حداکثر کش بک" },
    {
      field: "CityName",
      header: "ویرایش",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"edit"}
            onClick={() => handleOpeEditItem(data)}
            className="icon-sm prime-bg text-white p-1 text-center rounded"
            color="gray"
          />
        </div>
      ),
    },
  ];

  const handleOpeEditItem = (data) => {
    setShowEditComponent(true);
    console.log(data);
    if (data) {
      setEditingShopId(data?.ShopId);
      reset({ ...defaultValues, ...data });
      setTokenValue(data?.token);
      setInitialLogo(data?.Logo);
      const handleQrCodeApiResponse = (data) => {
        setLangData(data?.data[0]?.LatLong);
        console.log(data?.data[0]?.LatLong);
        setQrcode(data?.qrcode);
      };
      const qrCodeBodyData = new FormData();
      qrCodeBodyData.append("shopid", data?.ShopId);
      fetchData("shopprofile", qrCodeBodyData, handleQrCodeApiResponse);
    } else {
      reset(defaultValues);
      setEditingShopId("");
      setTokenValue("");
      setInitialLogo("");
      setQrcode("");
    }

    dispatch(getProvince());
    const proviceOptions = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.provinceid,
        label: item.provincename,
      }));
    };
    const provinceData = proviceOptions(province);
    setProvinceList(provinceData);
  };
  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    fetchData("shoplist", bodyFormData, handleApiResponse);
    fetchData("catlist", {}, handleCatResponse);
    fetchData("userlist", {}, handleUserResponse);
  }, []);

  const handleApiResponse = (data) => {
    setPageData(data?.dt);
    setTotalRecords(data?.count);
  };
  const handleUserResponse = (data) => {
    const value = data?.dt;
    const mapOptions = (value) => {
      return value?.map((item) => ({
        value: item.uid,
        label: `${item.Name} ${item.Family}`,
      }));
    };
    const values = mapOptions(value);
    setUserList(values);
  };
  const handleCatResponse = (data) => {
    const mapCats = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.catid.toString(),
        label: item.name,
      }));
    };
    setCategoryList(mapCats(data?.dt));
  };

  const schema = yup.object({
    Title: yup.string().required("نام فروشگاه وارد نشده است."),
    CatId: yup.string().required("دسته بندی انتخاب نشده است."),
    managermob: yup.string().required("شماره مدیر انتخاب نشده است "),
    type: yup.string().required("نوع فروشگاه انتخاب نشده است."),
    MinimumCashBack: yup.string().required("حداقل کش بک انتخاب نشده است."),
  });

  const typeOptions = [
    { label: "اینترنتی", value: 1 },
    { label: "حضوری", value: 2 },
  ];

  const {
    watch,
    handleSubmit,
    control,
    register,
    reset,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  useEffect(() => {
    const fetchData = async () => {
      const bodyFormData = new FormData();
      bodyFormData.append("provinceId", watch("ProvinceId"));
      try {
        const response = await axios.post(BASE_URL, bodyFormData, {
          headers: {
            "Content-type": "multipart/form-data",
            Accept: "application/json",
            cmd: "city",
          },
        });
        if (response.status === 200) {
          const data = await response.data;

          return data?.dt;
        } else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      } catch (error) {
        throw error;
      }
    };
    if (!watch("ProvinceId")) {
      setCityList([]);
      return;
    }
    fetchData().then((value) => {
      const mapOptions = (apiResponse) => {
        return apiResponse?.map((item) => ({
          value: item.cityid,
          label: item.cityname,
        }));
      };
      const data = mapOptions(value);
      setCityList(data);
    });
  }, [watch("ProvinceId")]);
  const onSubmit = async (data, image) => {
    let status;
    // if (data?.status) {
    //   status = 1;
    // } else {
    //   status = 0;
    // }
    const bodyFormData = new FormData();
    bodyFormData.append("catid", data?.CatId);
    bodyFormData.append("title", `${data?.Title}`);
    bodyFormData.append("tel", `${data?.tel}`);
    bodyFormData.append("address", `${data?.Address}`);
    bodyFormData.append("token", data?.token || tokenValue);
    bodyFormData.append("logo", image || initialLogo);
    bodyFormData.append("minimumcashback", data?.MinimumCashBack);
    bodyFormData.append("website", data?.WebSite);
    bodyFormData.append("shopdesc", data?.ShopDesc);
    bodyFormData.append("managermob", data?.managermob);
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("city", data?.CityId);
    bodyFormData.append("province", data?.ProvinceId);
    bodyFormData.append("shopreagentmob", data?.shopreagentmob);
    bodyFormData.append("shoptaminmob", data?.shoptaminmob);
    bodyFormData.append("status", data?.status ? 1 : 0);
    bodyFormData.append("type", data?.type);
    bodyFormData.append("latlong", langData);

    let cmd = "createshop";
    if (editingShopId) {
      bodyFormData.append("shopid", editingShopId);
      cmd = "updateshop";
    }
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: cmd,
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        const data = responseGlobal.data;
        setLogo(null);
        reset();
        fetchData("shoplist", bodyFormData, handleApiResponse);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };
  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const excelList = pageData?.map((item) => ({
        نام: item.Title,
        "تاریخ عضویت": item.CreateDate,
        " دسته بندی": item.catname,
        "حداقل کش بک": item.MinimumCashBack,
        "حداکثر کش بک": item.MaxsimumCashBack,
      }));
      const worksheet = xlsx.utils.json_to_sheet(excelList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "products");
    });
  };
  const header = (
    <FontAwesomeIcon
      icon={"file-excel"}
      onClick={exportExcel}
      className=" p-2 rounded  bg-info text-white"
    />
  );
  const shopTypeIdToValue = (shopType) => {
    if (shopType === 1) {
      return "اینترنتی";
    } else if (shopType === 2) {
      return "حضوری";
    }
  };
  const handlesetLatLong = (data) => {
    console.log(data, "lat");
    // const [lat, lng] = {...data}

    // console.log(lat,lng)
    setLangData(data);
  };

  const handleUpload = async (w, h, sednFile, data) => {
    console.log(data);
    // if (!sednFile) {
    //     return;
    // }
    let myImage;
    const image = new Image();
    image.src = sednFile;
    const cWith = w;
    const cHeight = h;
    let percentWidth = 0;
    let percentHeight = 0;
    image.onload = async () => {
      const canvas = document.createElement("canvas");
      const orginalWidht = image.naturalWidth;
      const orginalHeight = image.naturalHeight;

      if (cWith === 0 || cHeight === 0) {
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
      } else {
        percentWidth = cWith / orginalWidht;
        percentHeight = cHeight / orginalHeight;
        const percent =
          percentHeight < percentWidth ? percentHeight : percentWidth;
        canvas.width = image.naturalWidth * percent;
        canvas.height = image.naturalHeight * percent;
      }
      canvas
        .getContext("2d")
        .drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(async (blob) => {
        myImage = new File([blob], "my-new-name.webp", { type: blob.type });
      }, "image/webp");
    };
    onSubmit(data, myImage);
  };

  const handleSendImage = (data) => {
    console.log(data);
    const width = 800;
    const height = 800;
    handleUpload(width, height, Logo, data);
  };
  const handleCopyClick = (event) => {
    const content = event.target.innerText;
    const textarea = document.createElement("textarea");
    textarea.value = content;
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    alert("توکن کپی شد. ");
  };

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
  };

  const formFields = [
    [
      {
        Component: TelInput,
        name: "Title",
        type: "text",
        label: "نام ",
        required: true,
      },
      {
        Component: InputFormat,
        name: "ShopDesc",
        type: "text",
        label: "توضیحات",
        required: true,
      },
    ],
    [
      {
        Component: DropDownFormat,
        control: control,
        label: "دسته بندی",
        options: categoryList,
        errors: errors,
        name: "CatI",
      },
      {
        Component: InputFormat,
        control: control,
        name: "MinimumCashBack",
        type: "text",
        label: "حداقل کش بک",
        required: true,
      },
    ],
    [
      {
        Component: TelInput,
        label: "شماره مدیر فروشگاه",
        type: "tel",
        name: "managermob",
        control: control,
        defaultValue: "",
        maxLength: "11",
        required: true,
      },
      {
        Component: InputFormat,
        control: control,
        name: "WebSite",
        type: "text",
        label: "وب سایت",
      },
    ],
    [
      {
        Component: DropDownFormat,
        control: control,
        label: "استان",
        options: ProvinceList,
        errors: errors,
        name: "ProvinceId",
      },
      {
        Component: DropDownFormat,
        control: control,
        label: "شهر",
        options: cityList,
        errors: errors,
        name: "CityId",
      },
    ],
    [
      // {
      //   Component: TelInput,
      //   label: "شماره تلفن",
      //   type: "tel",
      //   name: "tel",
      //   control: control,
      //   defaultValue: "",
      //   maxLength: "11",
      //   required: true,
      // },
      {
        Component: TelInput,
        label: "شماره معرف فروشگاه",
        type: "tel",
        name: "shopreagentmob",
        control: control,
        defaultValue: "",
        maxLength: "11",
      },
      {
        Component: SelectFormat,
        label: "نوع فروشگاه",
        type: "tel",
        name: "type",
        placeholder: " نوع فروشگاه را انتخاب کنید ",
        control: control,
        options: typeOptions,
        required: true,
        onChange: handleTypeChange,
        errors,
      },
    ],
    [
      // {
      //   Component: TelInput,
      //   label: "شماره ارائه دهنده سایت",
      //   type: "tel",
      //   name: "shoptaminmob",
      //   control: control,
      //   defaultValue: "",
      //   maxLength: "11",
      //   required: true,
      // },
      {
        Component: InputFormat,
        control: control,
        name: "Address",
        type: "textarea",
        label: "آدرس",
      },
      {
        Component: CheckboxFormat,
        control: control,
        name: "status",
        type: "textarea",
        label: "وضعیت نمایش",
        errors: errors,
      },
    ],
  ];
  const inputSets = {
    1: [
      [
        {
          Component: TelInput,
          label: "شماره ارائه دهنده سایت",
          type: "tel",
          name: "shoptaminmob",
          control: control,
          defaultValue: "",
          maxLength: "11",
        },
      ],
    ],
    2: [
      [
        {
          Component: InputFormat,
          control: control,
          name: "WebSite",
          type: "text",
          label: "اینستاگرام",
        },
        {
          Component: InputFormat,
          control: control,
          name: "WebSite",
          type: "text",
          label: "تلگرام",
        },
      ],
      [
        {
          Component: InputFormat,
          control: control,
          name: "WebSite",
          type: "text",
          label: "روبیکا",
        },
        {
          Component: InputFormat,
          control: control,
          name: "WebSite",
          type: "text",
          label: "واتزاپ",
        },
      ],
      [
        {
          Component: InputFormat,
          control: control,
          name: "WebSite",
          type: "text",
          label: "ایتا",
        },
      ],
    ],
  };

  return (
    <PanelContainer title={"فروشگاه ها"}>
      <DataTableTemplate
        lazyState={lazyState}
        // header={header}
        // select='select'
        className={"table-border"}
        columns={cols}
        list={pageData}
        totalRecords={totalRecords}
        setlazyState={setLazyState}
        setDefaultDatatableRows={setDefaultDatatableRows}
        defaultDatatableRows={defaultDatatableRows}
        width="25rem"
        header={header}
      />
      <div className="col-6 mt-5">
        <div className="d-flex flex-row flex-wrap gap-1 mt-2">
          <Button
            // className="btn-primary"
            className=""
            type={"button"}
            onClick={() => handleOpeEditItem()}
          >
            افزودن فروشگاه جدید
          </Button>
          <Button
            type={"button"}
            className="btn-success"
            onClick={() => navigate("/cpanel/shopcategory")}
          >
            افزودن دسته بندی فروشگاه
          </Button>
        </div>
      </div>

      {showEditComponent && (
        <div className="edit row pt-5">
          <Form dir="rtl" onSubmit={handleSubmit(handleSendImage)}>
            <Row>
              <Col className=" col-12 col-lg-6">
                <Form.Label className="fw-bold pb-1">
                  {"لوگو فروشگاه"}
                </Form.Label>
                <img
                  id="avatar"
                  className="avatar"
                  onClick={() => document.getElementById("fileInput").click()}
                  alt="avatar"
                  src={
                    !Logo ? (initialLogo ? `${initialLogo}` : AvatarImg) : Logo
                  }
                />
                <input
                  type="file"
                  id="fileInput"
                  className="d-none"
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      setLogo(URL.createObjectURL(e.target.files[0]));
                    }
                  }}
                />
                <button
                  id="btn-upload"
                  className="d-none"
                  type="button"
                  onClick={() => handleSendImage()}
                >
                  click
                </button>
                <div id="progressbar" className="d-none text-center">
                  <p className="text-center">در حال بارگزاری فایل</p>
                  <progress content="10" id="fileProgress"></progress>
                </div>
                <br />
                <br />
              </Col>
              <Col>
                {qrcode && (
                  <img
                    id=""
                    className="qrcode"
                    // onClick={() => document.getElementById("fileInput").click()}
                    alt="avatar"
                    src={!Logo ? (qrcode ? `${qrcode}` : AvatarImg) : Logo}
                  />
                )}
              </Col>
            </Row>
            {formFields.map((rowFields, rowIndex) => (
              <Row key={rowIndex}>
                {rowFields.map(({ Component, ...fieldProps }, colIndex) => (
                  <Col
                    key={colIndex}
                    className={
                      Component?.className
                        ? Component?.className
                        : "col-12 col-lg-6"
                    }
                  >
                    <Component
                      control={control}
                      errors={errors}
                      register={register}
                      {...fieldProps}
                    />
                  </Col>
                ))}
              </Row>
            ))}
            {selectedType && (
              <>
                {inputSets[selectedType]?.map((inputSet, setIndex) => (
                  <Row key={setIndex}>
                    {inputSet?.map(
                      ({ Component, ...fieldProps }, inputIndex) => (
                        <Col
                          key={inputIndex}
                          className={
                            Component?.className
                              ? Component?.className
                              : "col-12 col-lg-6"
                          }
                        >
                          <Component
                            control={control}
                            errors={errors}
                            register={register}
                            {...fieldProps}
                          />
                        </Col>
                      )
                    )}
                  </Row>
                ))}
              </>
            )}

            <Col className=" col-12 col-lg-6 d-flex align-items-center gap-1 flex-wrap">
              <div
                onClick={handleCopyClick}
                className="btn btn-light text-wrap"
                style={{ userSelect: "unset" }}
              >
                {tokenValue}
              </div>
            </Col>

            <Row>
              <Col className=" col-12 col-lg-6 p-2">
                <Button type="button" onClick={() => setShowMap(true)}>
                  نمایش نقشه
                </Button>
              </Col>
            </Row>
            <Row>
              {showMap && (
                <BranchesLoc setLatLong={handlesetLatLong} value={langData} />
              )}
            </Row>
            <Row>
              <div className="col-6 col-lg-12 mt-2">
                <Button type="submit">ذخیره</Button>
              </div>
            </Row>
          </Form>
        </div>
      )}
    </PanelContainer>
  );
};
